import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserInfo } from "./UserInfo";
import {
  fetchCurrentUser,
  updateNotificationPreferences,
  updateUserDetails,
} from "../../slices/users";

export default function Profile({ setActiveTab }) {
  const dispatch = useDispatch();

  const { user, status, error } = useSelector((state) => state.user);

  useEffect(() => {

    if (!user && status !== "loading") {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch, user, status]); 
  const handleManagePreferences = useCallback(
    (preferenceKey, value) => {
      if (!user) return;

      const payload = {
        ...user.notification_settings,
        [preferenceKey]: value.checked,
      };

      dispatch(updateNotificationPreferences(payload));
    },
    [dispatch, user]
  );

  const handleEditProfile = useCallback(
    (key, value) => {
      if (!user) return;

      const payload = {
        [key]: value,
      };

     setTimeout(() => {
      dispatch(updateUserDetails(payload));
      }, 3000);
    },
    [dispatch, user]
  );

  return (
    <div className="row address-list-container">
      <UserInfo
        user={user}
        isLoading={status === "loading"}
        error={error}
        onEditProfile={handleEditProfile}
        onManagePreferences={handleManagePreferences}
        onManageAddresses={() => {
          setActiveTab("Addresses");
        }}
        onManagePayments={() => {
          setActiveTab("Payments");
        }}
        onSecuritySettings={() => {
          setActiveTab("Security");
        }}
      />
    </div>
  );
}